import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SWOffering from "@/pages/SWOffering";

export const Route = createFileRoute("/zh-cn/services/software-solutions-services/it-infrastructure-qualification")({
  head: () => buildRouteHead("/zh-cn/services/software-solutions-services/it-infrastructure-qualification"),
  component: SWOffering,
});

